import { withStyles } from '@material-ui/core';
import { withUserProfile } from '../../../../../../../../userProfile/userProfileContext';
import { formatDateTime, formatTime } from '../../utils';
import styles from '../styles';
import { compose } from 'recompose';
import Detail from './Detail';
import { withAppConfig } from '../../../../../../../../appConfigContext';

const PickupDetails = ({ classes, pickupInfo, userData, terminalCode, configJSON }) => {
  return (
    <div>
      <div className={classes.sectionTitle}>Pickup Details</div>
      <div className={classes.pickupDetailsInfoContainer}>
        <div className={classes.pickupDetailsColContainer}>
          <Detail title="Assigned By :" value={pickupInfo.assignedBy} />
          <Detail title="Contact :" value={pickupInfo.shipperContactName} />
          <Detail title="Created by :" value={pickupInfo.createdBy} />
          <Detail title="Zone :" value={pickupInfo.dispatchZone} />
        </div>
        <div className={classes.pickupDetailsColContainer}>
          <Detail title="Assigned Time :" value={formatTime(pickupInfo.pickupAssignedDateTime)} />
          <Detail title="Terminal :" value={terminalCode || userData.userProfile.terminal.code} />
          <Detail
            title="Created Date & Time :"
            value={formatDateTime(pickupInfo.createdDateTime)}
          />
          <Detail
            title="Driver :"
            value={`${pickupInfo.driverName ?? ''} ${
              pickupInfo.driverNumber ? `(#${pickupInfo.driverNumber})` : ''
            }`}
          />
        </div>
        <div className={classes.pickupDetailsColContainer}>
          <Detail
            title="Route :"
            value={configJSON?.showStaticRoute ? pickupInfo.staticRoute : pickupInfo.routeName}
          />
          {pickupInfo.driverNumber && (
            <>
              <Detail title="Manifest# :" value={pickupInfo.manifestNumber} />
              <Detail title="Tractor# :" value={pickupInfo.tractorNumber} />
              <Detail title="Trailer# :" value={pickupInfo.trailerNumber} />
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default compose(withUserProfile, withStyles(styles), withAppConfig)(PickupDetails);
